import { createSlice } from "@reduxjs/toolkit";
import { Manager } from "socket.io-client";

import { env } from "@/lib/env";
import { isAdminDomain, isSubDomain } from "@/lib/utils";
import { getCustomerId, getWorkspace } from "@/utils/helpers";

const initialState = {
  expanded: true,
  hover: false,
  mobileExpand: false,
  isOpen: false,
  manager: new Manager(env.SOCKET_URL, {
    secure: true,
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    ...(!isAdminDomain
      ? {
          query: {
            [isSubDomain ? "workspaceId" : "customerId"]: isSubDomain
              ? getWorkspace()
              : getCustomerId(),
          },
        }
      : {}),
  }),
};

export const configSlice = createSlice({
  name: "Config",
  initialState,
  reducers: {
    toggleExpanded: (state) => {
      state.expanded = !state.expanded;
    },
    toggleMobileExpanded: (state) => {
      state.mobileExpand = !state.mobileExpand;
    },
    hoverExpanded: (state, action) => {
      state.hover = action.payload;
    },
    HideExportTable: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const {
  toggleExpanded,
  hoverExpanded,
  toggleMobileExpanded,
  HideExportTable,
} = configSlice.actions;

export default configSlice.reducer;
